(function () {
  // ===== Helpers =====
  function getJSONAttr(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }
  function money(cents, currency) {
    if (typeof cents !== 'number') return '';
    var val = (cents / 100).toFixed(2);
    return (currency ? currency + ' ' : '') + val;
  }

  // ===== PDP capture into localStorage (safe if not present) =====
  try {
    var pdNode = document.querySelector('script[type="application/json"][data-section-type="static-recently-viewed"][data-section-data]');
    if (pdNode) {
      var pd = getJSONAttr(pdNode);
      if (pd && pd.product) {
        var key = (pd.settings && pd.settings.storageKey) || 'recently_viewed';
        var maxKeep = (pd.settings && pd.settings.maxItems) || 12;
        var list = [];
        try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }

        list.unshift(pd.product);
        var seen = new Set();
        list = list.filter(function (p) {
          if (!p || !p.handle) return false;
          if (seen.has(p.handle)) return false;
          seen.add(p.handle);
          return true;
        }).slice(0, maxKeep);

        localStorage.setItem(key, JSON.stringify(list));
      }
    }
  } catch (e) {}

  // ===== Render all RV blocks =====
  function renderAll() {
    var cfgNodes = document.querySelectorAll('script[type="application/json"][data-rv-config]');
    cfgNodes.forEach(function (cfgNode) {
      var cfg = getJSONAttr(cfgNode);
      if (!cfg) return;

      var container = document.getElementById(cfg.containerId);
      if (!container) return;

      var tabEl = document.querySelector('[data-rv-tab="' + cfg.tabId + '"]');
      var key = cfg.storageKey || 'recently_viewed';

      var list = [];
      try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }

      // --- NEW: exclude the current PDP product from the render ---
        var currentHandle = null;

        // Try to read handle from the PDP JSON (best source)
        var pdScript = document.querySelector(
        'script[type="application/json"][data-section-type="static-recently-viewed"][data-section-data]'
        );
        var pdData = getJSONAttr(pdScript);
        if (pdData && pdData.product && pdData.product.handle) {
        currentHandle = pdData.product.handle;
        } else {
        // Fallback: parse from URL if we're on a /products/... page
        var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        if (m) currentHandle = m[1];
        }

        // Filter the current product out of the list (PDP only)
        if (currentHandle) {
        list = list.filter(function (p) {
            return p && p.handle !== currentHandle;
        });
        }


      if ((!list || !list.length) && cfg.onlyWhenAvailable) {
        if (tabEl) {
          var wasActive = tabEl.classList.contains('active');
          tabEl.style.display = 'none';

          // If RV was active, switch to the first *visible* tab and its panel
          if (wasActive) {
            // Scope to this section wrapper
            var wrap = tabEl.closest('.index-tabs-collections-wrapper') || document;

            // 1) Switch active tab class
            var firstVisibleTab = wrap.querySelector('.index-tabs_nav--item:not([style*="display: none"])');
            if (firstVisibleTab) {
              wrap.querySelectorAll('.index-tabs_nav--item').forEach(function(a){ a.classList.remove('active'); });
              firstVisibleTab.classList.add('active');

              // 2) Switch active panel
              var targetId = firstVisibleTab.getAttribute('data-href');
              if (targetId) {
                wrap.querySelectorAll('.index-tabs-content_block').forEach(function(p){ p.classList.remove('active'); });
                var targetPanel = wrap.querySelector('#' + CSS.escape(targetId));
                if (targetPanel) targetPanel.classList.add('active');
              }
            }
          }
        }

        var panel = container.closest('.index-tabs-content_block');
        if (panel) panel.style.display = 'none';
        return;
      }

      // Ensure RV tab/panel are visible when we do have items
      if (tabEl) tabEl.style.display = '';
      var _panel = container.closest('.index-tabs-content_block');
      if (_panel) _panel.style.display = '';


      if (!list || !list.length) return;

      var tpl = document.getElementById('rv-card-template-' + cfg.blockId);
      if (!tpl) return;

      var frag = document.createDocumentFragment();
      var max = cfg.maxItems || 10;

      list.slice(0, max).forEach(function (p) {
        var node = tpl.content.cloneNode(true);

        // Links + title
        var aImg = node.querySelector('[data-rv="link-image"]');
        var aTit = node.querySelector('[data-rv="link-title"]');
        if (aImg) aImg.href = p.url || '#';
        if (aTit) aTit.href = p.url || '#';

        var titleEl = node.querySelector('[data-rv="title"]');
        if (titleEl) {
          titleEl.textContent = p.title || '';
          if (aTit) aTit.setAttribute('aria-label', p.title || '');
        }

        // Vendor
        var vLink = node.querySelector('[data-rv="vendor-link"]');
        if (vLink) {
          if (cfg.showVendor && p.vendor) {
            vLink.textContent = p.vendor;
            // Optionally link to vendor collection:
            // vLink.href = '/collections/' + (p.vendor || '').toLowerCase().replace(/\s+/g, '-');
          } else {
            if (vLink.parentNode) vLink.parentNode.remove();
          }
        }

        // Images
        var imgMain = node.querySelector('[data-rv="img-main"]');
        var imgAlt  = node.querySelector('[data-rv="img-alt"]');
        if (imgMain) {
          imgMain.src = p.image || '';
          imgMain.alt = p.title || '';
        }
        if (imgAlt && p.image_alt) {
          imgAlt.src = p.image_alt;
          imgAlt.alt = p.title || '';
          imgAlt.style.display = '';
        }

        // Reviews
        var rb = node.querySelector('[data-rv="reviews-badge"]');
        var rl = node.querySelector('[data-rv="reviews-link"]');
        if (rb) rb.setAttribute('data-id', p.id || '');
        if (rl) rl.href = (p.url || '#') + '#product-reviews';

// --- PRICING + SALE BADGE (matches featured card) ---
var priceSale    = node.querySelector('[data-rv="price-sale"]');
var priceRegWrap = node.querySelector('.price__regular');
var priceReg     = node.querySelector('[data-rv="price-regular"]');
var priceCmpWrap = node.querySelector('.price__compare');
var priceCmp     = node.querySelector('[data-rv="price-compare"]');

function isNum(n){ return typeof n === 'number' && !isNaN(n); }
function moneyFmt(val, curr){
  if (typeof val === 'string' && val.trim()) return val; // already formatted
  if (isNum(val)) return money(val, curr);               // cents -> formatted
  return '';
}
function toFloat(val){
  if (isNum(val)) return val / 100; // cents -> dollars
  if (typeof val === 'string'){
    var m = val.replace(/[^\d.,]/g, '').replace(',', '.');
    var f = parseFloat(m);
    return isNaN(f) ? null : f;
  }
  return null;
}

var saleText    = p.price_str || moneyFmt(p.price, p.currency);
var compareText = p.compare_at_price_str || moneyFmt(p.compare_at_price, p.currency);
var priceNum    = toFloat(p.price);
var compareNum  = toFloat(p.compare_at_price);
var onSale      = (priceNum != null && compareNum != null) ? (compareNum > priceNum) : false;

// Write amounts
if (priceSale) priceSale.textContent = saleText;

// IMPORTANT: Featured card shows the same amount in "regular" even when not on sale
if (priceReg)  priceReg.textContent  = saleText;

// Keep compare wrapper in DOM; only fill it when on sale
if (priceCmp && priceCmpWrap) {
  priceCmp.textContent = onSale ? compareText : '';
  // do NOT toggle display to match structure
}

// Show/hide sale badge
var labelList = node.querySelector('.product-item__label-list');
if (labelList) labelList.style.display = onSale ? '' : 'none';


        // ATC form
        var card     = node.querySelector('.product-card');
        var form     = node.querySelector('[data-rv="atc-form"]');
        var varInput = node.querySelector('[data-rv="variant-id"]');

        if (card && p.id) card.setAttribute('data-product-id', String(p.id));

        var prodIdInput = node.querySelector('[data-rv="product-id"]');
        if (prodIdInput && p.id) prodIdInput.value = p.id;

        if (form) {
        var sid = (cfg.sectionId || 'rv');
        form.id = 'product_form_id_' + (p.id || '0') + '_' + sid;
        }

        if (form && varInput) {
          if (p.variant_id) {
            varInput.value = p.variant_id;
          } else if (p.url) {
            fetch(p.url + '.js')
              .then(function (r) { return r.json(); })
              .then(function (prod) {
                var v = (prod.variants || []).find(function (vv) { return vv.available; }) || (prod.variants || [])[0];
                if (v && v.id) varInput.value = v.id;
              })
              .catch(function () {});
          }
        }

                // ===== ATC BUTTON STATE (disable + "Out of stock" when unavailable) =====
        var atcBtn = form ? form.querySelector('button[type="submit"], [type="submit"], .product-form__submit, .btn') : null;

        // Prefer variant availability (variant-specific). Fallback to product.available if missing.
        var isAvailable = typeof p.variant_available === 'boolean' ? p.variant_available
                        : (typeof p.available === 'boolean' ? p.available : true);

        function setATCState(available) {
          if (!atcBtn) return;
          if (!available) {
            atcBtn.textContent = 'Out of stock';
            atcBtn.setAttribute('disabled', 'disabled');
            atcBtn.setAttribute('aria-disabled', 'true');
            atcBtn.classList.add('is-disabled', 'rv-oos');
          } else {
            // If your theme uses a data-label for the default text, keep it; else fall back.
            var defaultLabel = atcBtn.getAttribute('data-label-add') || 'Add to cart';
            atcBtn.textContent = defaultLabel;
            atcBtn.removeAttribute('disabled');
            atcBtn.removeAttribute('aria-disabled');
            atcBtn.classList.remove('is-disabled', 'rv-oos');
          }
        }

        // Initial state from localStorage JSON
        setATCState(isAvailable);

        // If we had to fetch a variant id, also update availability from that variant
        if (form && varInput && !p.variant_id && p.url) {
          fetch(p.url + '.js')
            .then(function (r) { return r.json(); })
            .then(function (prod) {
              var v = (prod.variants || []).find(function (vv) { return vv.available; }) || (prod.variants || [])[0];
              if (v && v.id) varInput.value = v.id;
              if (v && typeof v.available === 'boolean') setATCState(v.available);
            })
            .catch(function () {});
        }

        // Block submit if disabled (belt & braces)
        if (form) {
          form.addEventListener('submit', function (e) {
            if (!atcBtn) return;
            var blocked = atcBtn.hasAttribute('disabled') || atcBtn.classList.contains('rv-oos');
            if (blocked) {
              e.preventDefault();
              e.stopPropagation();
            }
          }, { passive: false });
        }


        frag.appendChild(node);
      });

      container.innerHTML = '';
      container.appendChild(frag);

      // Carousel
      if (cfg.isCarousel) {
        try {
          var optJson = container.getAttribute('data-flickity-config');
          var opts = optJson ? JSON.parse(optJson) : {};
          if (window.Flickity) {
            setTimeout(function () { new Flickity(container, opts); }, 0);
          }
        } catch (e) {}
      }
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }

  // for debugging
  window.__rvRender = renderAll;
})();